import type { TableColumnMeta } from '../common/ColumnSelector';

/** Column catalogue for the non-TPM connection-attempt table. */
export const NON_TPM_COLUMN_METADATA: TableColumnMeta[] = [
  { id: 'device_id', label: 'Device ID', category: 'Basic Info' },
  { id: 'mac_address', label: 'MAC Address', category: 'Basic Info' },
  { id: 'tpm_error_message', label: 'TPM Error', category: 'Diagnostics' },
  { id: 'attempt_count', label: 'Attempts', category: 'Diagnostics' },
  { id: 'last_attempt_at', label: 'Last Attempt', category: 'Diagnostics' },
  { id: 'status', label: 'Status', category: 'Access' },
  { id: 'temporary_access_expires_at', label: 'Access Expires', category: 'Access' },
  { id: 'actions', label: 'Actions', category: 'Actions', alwaysVisible: true },
];

/** Everything, so the table opens on exactly the columns it always showed. */
export const NON_TPM_DEFAULT_COLUMNS = NON_TPM_COLUMN_METADATA.map((column) => column.id);
